import { usePaginatedApi } from "../../../swr/useApi";
import { salesService } from "../../api_client";
import type { SaleDto, SalesQueryDto } from "../../../api";
import { SalesQueryDtoStateEnum } from "../../../api";

export type OrdersFilter = "all" | "delivered" | "inTransit" | "processing" | "cancelled" | "needsConfirmation";

const FILTER_MAPPING: Record<OrdersFilter, Partial<SalesQueryDto>> = {
  all: { state: "confirmed" as SalesQueryDtoStateEnum },
  delivered: { state: "confirmed" as SalesQueryDtoStateEnum },
  inTransit: { state: SalesQueryDtoStateEnum.Sale },
  processing: { state: SalesQueryDtoStateEnum.Sale },
  cancelled: { state: SalesQueryDtoStateEnum.Cancel },
  needsConfirmation: { state: "confirmed" as SalesQueryDtoStateEnum, buyerReceived: false },
};

export function useOrders(
  filter: OrdersFilter,
  query?: Omit<SalesQueryDto, "state" | "inDelivery" | "buyerReceived">,
) {
  const finalQuery: SalesQueryDto = { ...query, ...FILTER_MAPPING[filter] };

  return usePaginatedApi<SaleDto, SalesQueryDto>({
    key: `orders-${filter}`,
    serviceMethod: async (q) => await salesService.getSales(q),
    query: finalQuery,
    options: { refreshInterval: 30_000 },
  });
}
